import { IAction } from "store";
import objectFilter from "utils/object-filter";

import { DealAction } from "../../actions";
import { IFolder, IMetaDetails, IWorkspaceMetadata, PatchFolderMetaDetailPayload } from "../../types";
import { reducer } from "../index";

reducer.createHandler(
  DealAction.GetFolderMetaSuccess,
  (state, { payload: folderMeta }: IAction<IWorkspaceMetadata>) => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      folderMeta
    }
  })
);

reducer.createHandler(
  DealAction.AppendFolderMetaDetails,
  (state, { payload }: IAction<IWorkspaceMetadata>) => {
    const existing = state.dealModule.folderMeta as IWorkspaceMetadata;
    if (!existing?.details) {
      return {
        ...state,
        dealModule: { ...state.dealModule, folderMeta: payload }
      };
    }
    return {
      ...state,
      dealModule: {
        ...state.dealModule,
        folderMeta: {
          ...existing,
          ...payload,
          details: [...existing.details, ...(payload.details ?? [])]
        }
      }
    };
  }
);

reducer.createHandler(DealAction.InvalidateFolderMeta, (state) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    folderMeta: {}
  }
}));

reducer.createHandler(DealAction.GetFoldersSuccess, (state, { payload }: IAction<Record<number, IFolder>>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    folders: payload
  }
}));

reducer.createHandler(DealAction.CreateFolderSuccess, (state, { payload }: IAction<IFolder>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    folders: { ...state.dealModule.folders, [payload.id]: payload }
  }
}));

reducer.createHandler(DealAction.UpdateFolderSuccess, (state, { payload }: IAction<IFolder>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    folders: { ...state.dealModule.folders, [payload.id]: payload }
  }
}));

reducer.createHandler(DealAction.DeleteFolderSuccess, (state, { payload }: IAction<number>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    folders: objectFilter(state.dealModule.folders, (item) => item.id !== payload)
  }
}));

reducer.createHandler(DealAction.ImportFoldersSuccess, (state, { payload }: IAction<IFolder[]>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    folders: {
      ...state.dealModule.folders,
      ...payload.reduce((acc, folder) => ({ ...acc, [folder.id]: folder }), {})
    }
  }
}));

reducer.createHandler(DealAction.PatchFolderMetaDetail, (state, { payload }: IAction<PatchFolderMetaDetailPayload>) => {
  const folderMeta = state.dealModule.folderMeta as IWorkspaceMetadata;
  if (!folderMeta?.details) return state;

  const details =
    payload.key === "delete"
      ? folderMeta.details.filter((item) => !(item.id === payload.id && item.entity_type === payload.entityType))
      : folderMeta.details.map((item) =>
          item.id === payload.id && item.entity_type === payload.entityType
            ? ({ ...item, ...payload.patch } as IMetaDetails)
            : item
        );

  return {
    ...state,
    dealModule: {
      ...state.dealModule,
      folderMeta: { ...folderMeta, details }
    }
  };
});
